// extracted by mini-css-extract-plugin
module.exports = {"modal":"_1UXQuA2B","textArea":"_1o-QDTlb","articlePreviewTitle":"_2vJIHXdO","link":"_2SBYhXFa"};